var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"pt-sans-bold footer-me"},[_vm._v(_vm._s(_vm.version)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }